import { Volume2, VolumeX } from "lucide-react";

import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import useVolumeDoAlerta from "../../hooks/useVolumeDoAlerta";

// Um controle só para todo som do sistema.
//
// Não havia como baixar nem calar: o alerta tocava sempre no volume cheio, a
// cada mensagem nova, e em sala com várias pessoas atendendo isso é o dia
// inteiro.
//
// Um ícone, no topo, ao lado do perfil — e não dois, um por lugar que toca
// som: com controles separados a pessoa calaria o sino e continuaria levando
// susto do chat interno. O ajuste é compartilhado (ver `useVolumeDoAlerta`),
// então quem toca som lê o mesmo valor.
const VolumeDoAlerta = () => {
  const { volume, mudo, setVolume, alternarMudo } = useVolumeDoAlerta();

  const porcentagem = Math.round(volume * 100);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={mudo ? "Som do alerta: mudo" : `Som do alerta: ${porcentagem}%`}
          title={mudo ? "Som do alerta: mudo" : `Som do alerta: ${porcentagem}%`}
        >
          {mudo ? (
            // Mudo é um estado que precisa ser visto de longe: sem a cor, a
            // pessoa passa a manhã achando que ninguém escreveu.
            <VolumeX className="h-5 w-5 text-destructive" />
          ) : (
            <Volume2 className="h-5 w-5" />
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent align="end" className="w-60 p-3">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium">Som do alerta</p>
          <span className="text-xs tabular-nums text-muted-foreground">
            {mudo ? "Mudo" : `${porcentagem}%`}
          </span>
        </div>

        <div className="mt-3 flex items-center gap-2">
          <button
            type="button"
            onClick={alternarMudo}
            aria-pressed={mudo}
            aria-label={mudo ? "Ligar o som" : "Silenciar"}
            title={mudo ? "Ligar o som" : "Silenciar"}
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          >
            {mudo ? (
              <VolumeX className="h-4 w-4" />
            ) : (
              <Volume2 className="h-4 w-4" />
            )}
          </button>

          <input
            type="range"
            min="0"
            max="100"
            step="5"
            value={porcentagem}
            onChange={(e) => setVolume(Number(e.target.value) / 100)}
            aria-label="Volume do alerta"
            className="h-1 w-full cursor-pointer accent-primary"
          />
        </div>

        <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
          Vale para as mensagens novas e para o chat interno. Fica guardado
          neste navegador.
        </p>
      </PopoverContent>
    </Popover>
  );
};

export default VolumeDoAlerta;
